export function createHOC(getWrapperComponent, wrapperName = 'withHOC') {
  return (WrappedComponent) => {
    const WrapperComponent = getWrapperComponent(WrappedComponent);
    WrapperComponent.router = WrappedComponent.router;

    WrapperComponent.displayName = `${wrapperName}(${getDisplayName(
      WrappedComponent
    )})`;

    return WrapperComponent;
  };
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
